// extracted by mini-css-extract-plugin
export default {"Wrapper":"style_Wrapper__Uxzeg","Container":"style_Container__LBZbO","link":"style_link__YfDmT"};